import type React from 'react';

import { TruncatedText } from '@vlabs/shared/components/truncated-text/TruncatedText';
import { CopyButton, useWindowSize } from '@vlabs/uikit';
import cn from 'classnames';

import { useEventDetailsGeneralInfoTranslation } from '../i18n';
import st from './shared.module.sass';

interface TrackIdRowProps {
  id: string;
}

function TrackIdRow({ id }: TrackIdRowProps): React.JSX.Element {
  const { t } = useEventDetailsGeneralInfoTranslation();
  const { width } = useWindowSize();

  return (
    <div className={st.RowValueWrapper}>
      <div
        className={cn(st.RowValue, {
          [st.RowValue_small]: width && width < 1920,
          [st.RowValue_large]: width && width >= 1920,
        })}
      >
        <TruncatedText
          hasTruncation
          tooltipContent={id}
        >
          {id}
        </TruncatedText>
      </div>
      <div className={st.CopyButton}>
        <CopyButton
          title={t('copy_button')}
          value={id}
        />
      </div>
    </div>
  );
}

export { TrackIdRow };
